export default "__VITE_ASSET__B1wyxEB2__"